export const loadShayariData = async (type = 'current') => {
    try {
        console.log('Attempting to load:', `/data/${type}-shayari.json`);
        const response = await fetch(`/data/${type}-shayari.json`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log('Loaded data:', data);
        return type === 'current' ? data.verses : data.sections;
    } catch (error) {
        console.error('Error loading shayari data:', error);
        return [];
    }
};

export const formatLegacyShayari = (section) => {
    return {
        id: section.id,
        title: section.title,
        text: section.text.split('\n').join('\n')
    };
};
